import { Form, Input, Select, Checkbox } from 'antd';
import * as _ from 'lodash';
import * as React from 'react';
import { Subscribe } from 'unstated';

import { debounceRate } from '../../../config/config';
import { StateContainer } from './StateContainer';
import PriceInput from '../../../components/Others/PriceInput';
import CustomerSelect from '../../../components/Others/CustomerSelect';

export interface IGeneralSettingsColProps {
  container: StateContainer;
  domain: string;
  allChangeStored: (allChangesStored: boolean) => void;
}

export default class GeneralSettingsCol extends React.Component<IGeneralSettingsColProps> {
  public constructor(props: IGeneralSettingsColProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onChange = _.debounce(this.onChange, debounceRate);

    this.validFrom = undefined;
    this.validTo = undefined;
  }

  private validFrom: any;
  private validTo: any;

  private allChangesStored() {
    return (!this.validFrom) && (!this.validTo);
  }

  public render() {
    const { container } = this.props;

    return (
      <Subscribe to={[container]}>
        {voucher => (
          <div>
            <Form layout={'horizontal'}>
              <Form.Item
                validateStatus={this.validateStatus('title')}
                help={this.validateMessage('title')}
                label={'Voucher code'}
                required={true}
              >
                <Input
                  name={'title'}
                  autoFocus={true}
                  placeholder="Voucher code"
                  defaultValue={voucher.state.voucher.title}
                  onChange={e => {
                    this.onChange('title', e.target.value);
                  }}
                />
              </Form.Item>
              <Form.Item
                validateStatus={this.validateStatus('pohodaIDS')}
                help={this.validateMessage('pohodaIDS')}
                label={'Pohoda IDS'}
                required={false}
              >
                <Input
                  name={'pohodaIDS'}
                  autoFocus={true}
                  placeholder="Pohoda IDS"
                  defaultValue={voucher.state.voucher.pohodaIDS}
                  onChange={e => {
                    this.onChange('pohodaIDS', e.target.value);
                  }}
                />
              </Form.Item>
              <Form.Item
                label={'Usage limit'}
                required={true}
                validateStatus={this.validateStatus('usageLimit')}
                help={this.validateMessage('usageLimit')}
              >
                <Input
                  name={'Usage limit'}
                  type={'number'}
                  defaultValue={voucher.state.voucher.usageLimit}
                  onChange={e => this.onChange('usageLimit', parseFloat(e.target.value))}
                />
              </Form.Item>
              <Form.Item
                label={'Valid from'}
                validateStatus={this.validateStatus('validFrom')}
                help={this.validateMessage('validFrom')}
              >
                <Input
                  name={'validFrom'}
                  type={'date'}
                  defaultValue={voucher.state.voucher.validFrom}
                  // Tohle způsobuje prodlevy v zobrazování kalendáře kvůli překreslování složitého formuláře
                  // onChange={e => this.onChange('validFrom', e.target.value)}
                  onChange={e => {
                    this.props.allChangeStored(false);
                    this.validFrom = e.target.value;
                  }}
                  onBlur={() => {
                    if (this.validFrom) {
                      // Protože všechny změny se kvůli přerendrovávání formuláře zapisují pomalu, byl přidaný callback spouštěný po zapsání změn
                      this.onChange('validFrom', this.validFrom, () => this.props.allChangeStored(this.allChangesStored()));
                      this.validFrom = null;
                  }}}
                />
              </Form.Item>
              <Form.Item
                label={'Valid to'}
                validateStatus={this.validateStatus('validTo')}
                help={this.validateMessage('validTo')}
              >
                <Input
                  name={'ValidTo'}
                  type={'date'}
                  defaultValue={voucher.state.voucher.validTo}
                  // Tohle způsobuje prodlevy v zobrazování kalendáře kvůli překreslování složitého formuláře
                  // onChange={e => this.onChange('validTo', e.target.value)}
                  // Tohle nepomohlo
                  // onChange={e => this.setState({validTo: e.target.value})}
                  // onBlur={() => this.state && this.state.validTo && this.onChange('validTo', this.state.validTo)}
                  onChange={e => {
                    this.props.allChangeStored(false);
                    this.validTo = e.target.value;
                  }}
                  onBlur={() => {
                    if (this.validTo) {
                      this.onChange('validTo', this.validTo, () => this.props.allChangeStored(this.allChangesStored()));
                      this.validTo = null;
                  }}}
                />
              </Form.Item>
              <Form.Item
                label={'Amount value'}
                validateStatus={this.validateStatus('validTo')}
                help={this.validateMessage('validTo')}
              >
                <PriceInput
                  name={'AmountValue'}
                  mode={'priceWithout'}
                  prices={Array.isArray(voucher.state.voucher.amountValue) ? voucher.state.voucher.amountValue : []}
                  onChange={(e: any) => this.onChange('amountValue', e.target.value)}
                />
              </Form.Item>
              <Form.Item label={'For customer'}>
                <CustomerSelect
                  name={'customerId'}
                  value={voucher.state.voucher.customerId || undefined}
                  onChange={(e: any) => this.onChange(e.target.name, e.target.value)}
                  domain={this.props.domain}
                />
              </Form.Item>
              <Form.Item>
                <Checkbox
                  name={'active'}
                  checked={voucher.state.voucher.active}
                  onChange={(e: any) => this.onChange(e.target.name, e.target.checked)}
                >
                  Active
                </Checkbox>
              </Form.Item>
            </Form>
          </div>
        )}
      </Subscribe>
    );
  }

  private onChange(key: string, val: any, callback?: () => void) {
    this.props.container.onChange(key, val, callback);
  }

  private validateMessage(field: string) {
    const error = this.props.container.state.errors[field];

    if (error) {
      return error;
    }

    return undefined;
  }

  private validateStatus(field: string) {
    const error = this.props.container.state.errors[field];

    if (error) {
      return 'error';
    }

    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Vouchers/VoucherDetail/GeneralSettingsCol.tsx